import React from "react";
import { Toast } from "react-bootstrap";

const CommonToast = ({ show, onClose, message, variant, color }) => {
  return (
    <div style={{ position: "fixed", top: 50, right: 20, zIndex: 1050 }}>
      <Toast show={show} onClose={onClose} bg={variant} delay={1000} autohide>
        <Toast.Header>
          <strong className="me-auto">
            {variant === "success" && "✅ Success"}
            {variant === "danger" && "❌ Error"}
            {variant === "warning" && "⚠️ Warning"}
          </strong>
        </Toast.Header>
        <Toast.Body style={{ color: color, fontWeight: "500" }}>{message}</Toast.Body>
      </Toast>
    </div>
  );
};

export default CommonToast;
